export default "__VITE_ASSET__Bne4u2kC__"